export const joinClasses = (...classes) => {
  const validClasses = [];
  classes.forEach((item) => {
    if (typeof item === "string") {
      validClasses.push(item);
    } else {
      for (let key in item) {
        if (item[key]) {
          validClasses.push(key);
        }
      }
    }
  });
  return validClasses.join(" ");
};

const materialUI = {
  joinClasses,
};

export default materialUI;
